import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDevolutionById, manageDevolutions } from '../../../actions/transferActions'
import DevolutionsDetailView from '../../../containers/Inventory/Devolutions/DevolutionsDetailView'

const DevolutionsDetaill = ({ match }) => {
  const { devolutionsDetail } = useSelector(state => state.tranfers)
  const [specifications, setSpecifications] = useState([])
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getDevolutionById(match.params.id))

    return () => {

    }
  }, [match.params.id])
  const erese = (devolutionDetail) => {

    const specification = {
      detailId: devolutionDetail._id,
      status: 1,
      batches: [
        devolutionDetail.originMainProductBatchId._id
      ]

    }

    if ( specifications.find(specificationVal =>   specificationVal.detailId ===specification.detailId ) ==undefined ) {
      setSpecifications(specificationsPrev => {
        return [...specificationsPrev, specification]
      })
    }else{
      if(specifications.find(specificationVal =>   specificationVal.detailId ===specification.detailId ).status ===2){
        setSpecifications(specificationsPrev => {
          specificationsPrev.map(specificationPrev =>{
            if(specificationPrev.detailId ===specification.detailId){
              specificationPrev.batches = [
                devolutionDetail.originMainProductBatchId._id
              ]
              specificationPrev.status = 1

            }
          })
          return [...specificationsPrev]
        })
      }
    }

    //  dispatch(manageDevolutions(1,1))

  }

  const refund = (devolutionDetail) => {
    //dispatch(manageDevolutions(1,1))
    const specification = {
      detailId: devolutionDetail._id,
      status: 2,


    }
    
    if ( specifications.find(specificationVal =>   specificationVal.detailId ===specification.detailId ) ==undefined ) {
      setSpecifications(specificationsPrev => {
        return [...specificationsPrev, specification]
      })
    }else{
      if(specifications.find(specificationVal =>   specificationVal.detailId ===specification.detailId ).status ===1){
        setSpecifications(specificationsPrev => {
          specificationsPrev.map(specificationPrev =>{
            if(specificationPrev.detailId ===specification.detailId){
              delete specificationPrev.batches
              specificationPrev.status = 2

            }
          })
          return  [...specificationsPrev]
        })
      }
    }
  }
  const accept = () =>{
 
    dispatch(manageDevolutions(match.params.id,specifications))
  }
  return (
    <DevolutionsDetailView devolutionsDetail={devolutionsDetail} erese={erese} refund={refund} specifications={specifications}  accept ={accept}/>
  )
}

export default DevolutionsDetaill